import { useQuery } from "@tanstack/react-query";
import { getInfoApiRequest } from "../../services";

export const useGetInfoApi = (clearToken?: () => void, reload?: boolean) => {
  const { data, isLoading } = useQuery({
    queryKey: ["info-detail", reload],
    queryFn: () => getInfoApiRequest(clearToken),
    enabled: true,
  });
  return {
    infoDetail: data,
    isLoading,
  };
};
